<span *ngIf="activeUserId === data.value.activeUserId" class="fw-bold" data-test-id="activity-unshared-you">{{
  'ACTIVITY_YOU' | translate
}}</span>
<app-activities-navigate-profile
  *ngIf="activeUserId !== data.value.activeUserId"
  [user]="data.value.ownerItem"
  [isDialog]="isDialog"
  [dataTestId]="'activity-unshared-navigate-to-profile'"
  (submit)="onSubmit()"
></app-activities-navigate-profile>

<span data-test-id="activity-unshared-stopped">&nbsp;{{ 'ACTIVITY_STOPPED' | translate }}</span>
<span data-test-id="activity-unshared-sharing">&nbsp;{{ 'ACTIVITY_SHARING' | translate }}</span>
<span *ngIf="isDialog" data-test-id="activity-unshared-this">&nbsp;{{ 'ACTIVITY_THIS' | translate }}</span>
<span data-test-id="activity-unshared-file">&nbsp;{{ 'ACTIVITY_FILE' | translate }}</span>
<app-activities-display-popup
  *ngIf="!isDialog"
  [rowIndex]="data.rowIndex"
  [value]="data?.value"
  [entityName]="data.value.entity_name"
  [dataTestId]="'activity-unshared-file-'"
  (displayPopup)="onDisplayPopup($event)"
></app-activities-display-popup>
{{ 'ACTIVITY_WITH' | translate }}
<span *ngFor="let user of data.value.users; index as i">
  <app-activities-navigate-profile
    [user]="user"
    [isDialog]="isDialog"
    [needComma]="i < data.value.users.length - 1"
    [isActiveUser]="activeUserId === user.user_id"
    [dataTestId]="'activity-unshared-file-name-' + i"
    (submit)="onSubmit()"
  ></app-activities-navigate-profile>
</span>
